import { ModalComponent } from "cruzo/ui-components/modal";
import { appScope } from "site/api";

export type ImageGalleryModalMode = "browse" | "pick";

export type ImageGalleryModalContext = {
  mode: ImageGalleryModalMode;
  initialPrompt?: string;
  /** Pre-select a gallery item (e.g. vocabulary auto-fill or current row image). */
  initialSelectedPath?: string;
  /** Shown in the modal status line (e.g. "Подставлено из словаря"). */
  initialStatusText?: string;
  onPick?: (path: string) => void;
};

let context: ImageGalleryModalContext | null = null;

export function openImageGalleryModal(next: ImageGalleryModalContext): void {
  context = next;
  ModalComponent.attach("imageGalleryModal", appScope.id);
}

export function getImageGalleryModalContext(): ImageGalleryModalContext | null {
  return context;
}

export function clearImageGalleryModalContext(): void {
  context = null;
}
